// extracted by mini-css-extract-plugin
export var addButton = "_4v-d";
export var bullets = "_4v-e";
export var compact = "_4v-2";
export var container = "_4v-j";
export var extendedWarrantyModal = "_4v-f";
export var learn = "_4v-l";
export var learnMore = "_4v-g";
export var offeringOption = "_4v-3";
export var offeringPrice = "_4v-8";
export var offeringSubtitle = "_4v-7";
export var offeringTitle = "_4v-6";
export var offeringsContainer = "_4v-0";
export var pdpTilesBackground = "_4v-n";
export var plan = "_4v-m";
export var regular = "_4v-1";
export var remove = "_4v-k";
export var seeDetailsIcon = "_4v-i";
export var seeDetailsLink = "_4v-h";
export var selectedOption = "_4v-4";
export var shieldIcon = "_4v-b";
export var shieldIconCompact = "_4v-c";
export var subtitle = "_4v-a";
export var title = "_4v-9";
export var unselectedOption = "_4v-5";